import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';

export default ({
  value = '', onChange = (e) => e, label = '', error = '', instantChange = true, helpText, step, min, max, stepIsMandatory, suffix, element, ...props
}) => {
  const [localValue, setValue] = useState(value);

  useEffect(() => {
    setValue(value);
  }, [value]);

  const onLocalBlur = (event) => {
    let currentValue = event !== undefined ? event.target.value : localValue;
    currentValue = currentValue && parseFloat(currentValue);
    if (step && stepIsMandatory) {
      const stepRound = 1 / parseFloat(step);
      currentValue = Math.round(currentValue * stepRound) / stepRound;
    }

    if (min !== undefined && currentValue < min) currentValue = min;
    if (max !== undefined && currentValue > max) currentValue = max;

    setValue(currentValue);
    onChange(currentValue);
  };

  const onLocalChange = (event) => {
    const currentValue = event.target.value;
    setValue(currentValue);

    if (instantChange) {
      onLocalBlur(event);
    }
  };

  const inputProps = {};
  if (suffix) {
    inputProps.InputProps = {
      endAdornment: <InputAdornment style={{ marginLeft: '5px' }} position="start">{suffix}</InputAdornment>,
    };
  }


  return (
    <>
      <TextField
        label={label}
        margin="normal"
        variant="outlined"
        value={localValue}
        onChange={onLocalChange}
        error={!!error}
        helperText={error || helpText}
        inputProps={{
          min,
          max,
          step,
          onBlur: !instantChange ? onLocalBlur : undefined,
        }}
        {...inputProps}
        {...props}
      />
      {
        element
      }
    </>
  );
};
